module.exports = __webpack_public_path__ + "img/ydd_qyh_code.4c8f83b7.png";